/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { loc } from "../../../core/utils"
import React from "react"
import { isMobile } from "react-device-detect"

const DEFAULT_PLACEMENT = isMobile ? "" : "align-self-center text-right"

export default function Field(props) {
  return !props.hide && props.value ? (
    <div className={"justify-content-between " + (isMobile ? "" : "d-flex")}>
      <div className="align-self-center">
        <p className="text-dark">{loc(props.name)}</p>
      </div>
      <div className={DEFAULT_PLACEMENT}>
        <p>{props.value}</p>
      </div>
    </div>
  ) : null
}
